import { render, staticRenderFns } from "./RadioSelector.vue?vue&type=template&id=2aba08e9&"
import script from "./RadioSelector.vue?vue&type=script&lang=js&"
export * from "./RadioSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports